import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { SpacePlanDto, SpacePlanPaymentPriceInfo } from '@zep/types';

import { useZepApiClient } from '../ZepApiProvider';

/**
 * @deprecated API type 마이그레이션이 필요합니다. README의 API Type Safety 가이드를 참고하세요: docs/api-type-safety.md
 */
export const usePurchaseOnetimePlan = (
  options?: UseMutationOptions<
    {
      status: number;
      statusKey: string;
      data: { spacePlan: SpacePlanDto };
    },
    AxiosError,
    {
      spaceHashId: string;
      spacePlanTemplateId: number;
      startDate: string;
      spacePlanHashId?: string;
    }
  >,
) => {
  const client = useZepApiClient();

  return useMutation(
    ['post-purchase-onetime-plan'],
    async payload => {
      if (payload.spacePlanHashId) {
        const { data } = await client.put('/space-plans/purchase-onetime', {
          ...payload,
        });
        return data;
      }
      const { data } = await client.post('/space-plans/purchase-onetime', {
        ...payload,
      });
      return data;
    },
    options,
  );
};

/**
 * @deprecated API type 마이그레이션이 필요합니다. README의 API Type Safety 가이드를 참고하세요: docs/api-type-safety.md
 */
export const useCancelPurchaseOnetimePlan = (
  options?: UseMutationOptions<
    {
      status: 0;
      statusKey: string;
      data: string;
    },
    AxiosError,
    {
      spaceHashId: string;
      spacePlanHashId: string;
    }
  >,
) => {
  const client = useZepApiClient();

  return useMutation(
    ['cancel-purchase-onetime-plan'],
    async payload => {
      const { data } = await client.post(
        `/space-plans/purchase-onetime/cancel`,
        payload,
      );
      return data;
    },
    options,
  );
};

/**
 * @deprecated API type 마이그레이션이 필요합니다. README의 API Type Safety 가이드를 참고하세요: docs/api-type-safety.md
 */
export const useGetOnetimeOrderInfo = (
  options?: UseMutationOptions<
    {
      status: 0;
      statusKey: string;
      data: {
        orderId: string;
        /**
         * 서버 VAT snapshot 금액 세트.
         * 서버 PR(VAT 정책) 합류 전에는 내려오지 않으므로 optional.
         * TODO: 서버 OpenAPI 완료 후 generated schema로 재생성
         */
        priceInfo?: SpacePlanPaymentPriceInfo;
      };
    },
    AxiosError,
    {
      spacePlanHashId: string;
    }
  >,
) => {
  const client = useZepApiClient();

  return useMutation(
    ['get-onetime-order-info'],
    async ({ spacePlanHashId }) => {
      const { data } = await client.get(
        `/space-plans/product-onetime/order-info?spacePlanHashId=${spacePlanHashId}`,
      );
      return data;
    },
    options,
  );
};
